/**
 * Article projections for listing and display
 */
export const getArticleProjection = (dataSource: string) => {
  if (dataSource === "replicator2025") {
    return {
      ArticleId: true,
      Title: true,
      DOI: true,
      PublishedDate: true,
      AcceptedDate: true,
      Published: true,
      ArticleType: true,
      ReceivedDate: true,
      Authors: true,
      ImpactV5: true,
      Journal: true,
      Image: true
    };
  } else {
    return {
      "ArticleId": true,
      "Title": true,
      "DOI": true,
      "RecentDate": true,
      "PublishedDate": true,
      "AcceptedDate": true,
      "Published": true,
      "ArticleType": true,
      "ReceivedDate": true,
      "Authors.FullName": true,
      "ImpactV5": true,
      "Journal": true,
      "Section": true,
      "ImageUrl": true
    };
  }
};

/**
 * Article projections for listing and display for Magazine
 */
export const getMagazineArticleProjection = (dataSource: string) => {
  if (dataSource === "replicator2025") {
    return {
      ArticleId: true,
      Title: true,
      DOI: true,
      PublishedDate: true,
      AcceptedDate: true,
      Published: true,
      ArticleType: true,
      ReceivedDate: true,
      Authors: true,
      ImpactV5: true,
      Journal: true,
      Section: true,
      Score: true,
      Abstract: true,
      BodyText: true,
      FieldCode: true,
      Image: true
    };
  } else {
    return {
      "ArticleId": true,
      "Title": true,
      "DOI": true,
      "RecentDate": true,
      "PublishedDate": true,
      "AcceptedDate": true,
      "Published": true,
      "ArticleType": true,
      "ReceivedDate": true,
      "Authors.FullName": true,
      "Authors.UserId": true,
      "Authors.Affiliations.Department": true,
      "Authors.Affiliations.Organization": true,
      "Authors.Affiliations.City": true,
      "Authors.Affiliations.Country": true,
      "ImpactV5": true,
      "Journal": true,
      "Section": true,
      "ImageUrl": true
    };
  }
};

/**
 * Author projections for extracting author information from articles
 */
export const getAuthorProjection = (dataSource: string) => {
  if (dataSource === "replicator2025") {
    return {
      Authors: true
    };
  } else {
    return {
      "Authors.Affiliations.Department": true,
      "Authors.Affiliations.Organization": true,
      "Authors.Affiliations.City": true,
      "Authors.Affiliations.Country": true,
      "Authors.Email": true,
      "Authors.FirstName": true,
      "Authors.FullName": true,
      "Authors.LastName": true,
      "Authors.MiddleName": true,
      "Authors.ShortName": true,
      "Authors.UserId": true
    };
  }
};

/**
 * Research Topic Ebook projections
 */
export const getResearchTopicEbookProjection = (dataSource: string) => {
  if (dataSource === "replicator2025") {
    return {
      ResearchTopicId: 1,
      FileDetails: 1
    };
  } else {
    return {
      ResearchTopicId: 1,
      EbookId: 1,
      FileServerVersionNumber: 1,
      FileServerId: 1,
      FileServerPackageEntryId: 1,
      FileName: 1,
      ContentTypeCode: 1,
      FileFormatDescription: 1
    };
  }
};

/**
 * Research Topic full projections (includes editors, stats, etc.)
 */
export const getResearchTopicProjection = (dataSource: string) => {
  if (dataSource === "replicator2025") {
    return {
      "ResearchTopicId": 1,
      "Slug": 1,
      "Title": 1,
      "Description": 1,
      "Journals.IsPrimary": 1,
      "Journals.JournalId": 1,
      "Journals.Sections.SectionId": 1,
      "Journals.Sections.Title": 1,
      "Journals.Sections.IsPrimary": 1,
      "Journals.Title": 1,
      "Journals.SpecialtyId": 1,
      "Journals.IsOnline": 1,
      "AbstractSubmissionDeadline": 1,
      "ClosedOn": 1,
      "OnlineSince": 1,
      "CreatedDate": 1,
      "ImageUrl": 1,
      "ImpactV5": 1,
      "IsOpenForSubmission": 1,
      "Keywords": 1,
      "ManuscriptSubmissionDeadline": 1,
      "ManuscriptSubmissionExtendedDeadline": 1,
      "StageId": 1,
      "TopicCoordinators": 1,
      "TopicEditors": 1,
      "CoverImageUrl": 1
    };
  } else {
    return {
      "ResearchTopicId": 1,
      "Slug": 1,
      "Title": 1,
      "Description": 1,
      "Journals.IsPrimary": 1,
      "Journals.JournalId": 1,
      "Journals.Sections.SectionId": 1,
      "Journals.Title": 1,
      "Journals.SpecialtyId": 1,
      "AbstractSubmissionDeadline": 1,
      "AuthorsCount": 1,
      "ClosedOn": 1,
      "OnlineSince": 1,
      "CreatedDate": 1,
      "ImageUrl": 1,
      "ImpactV5": 1,
      "IsOpenForManuscriptSubmission": 1,
      "IsOpenForSubmission": 1,
      "Keywords": 1,
      "ManuscriptSubmissionDeadline": 1,
      "ManuscriptSubmissionExtendedDeadline": 1,
      "StageId": 1,
      "TopicCoordinators": 1,
      "TopicEditors": 1
    };
  }
};
